import Routes from '../Routes';

class Base {

  static render(selector, options = {}) {

    const component = (this.getComponents() || {})[selector];
    if (!component) return console.warn(`Component not found for selector: ${selector}`);

    return component(`#${selector}`, options);
  }

  static buildRoute(name, params = {}) {

    if(!name) {
      throw new Error('Name property not found. A route must have a name!');
    }

    const path = name.split('.').reduce((memo, item)=> memo[item], Routes);

    return Object.keys(params).reduce((memo, item)=>
      memo.replace(`{${item}}`, params[item])
    , path);
  }

  static redirect(name, params = {}, timeout = 1700) {
     setTimeout(()=> {
       window.location.href = this.buildRoute(name, params);
     }, timeout);
  }

};

export default Base;
